<template>
  <CustomLink
    :url="itemSlug"
    class="help-menu-item block transition-colors hover:bg-EXPONDO-grey-5"
    :class="{
      'font-bold bg-EXPONDO-grey-5': isActive,
      'border-b': !isLastMenuItem,
    }"
    :type="LINK_TYPE.NoStyle"
    :is-block="true"
  >
    <div class="py-2 px-3 cursor-pointer">
      {{ itemName }}
    </div>
  </CustomLink>
</template>

<script lang="ts">
import CustomLink from '~/components/atoms/Link/CustomLink.vue';
import { LINK_TYPE } from '~~/types/components/Link/LinkType';

export default defineComponent({
  components: {
    CustomLink,
  },
  props: {
    currentItemIndex: {
      type: Number,
      required: true,
    },
    totalItemsCount: {
      type: Number,
      required: true,
    },
    itemSlug: {
      type: String,
      required: true,
    },
    itemName: {
      type: String,
      required: true,
    },
    isMobileMenuOpen: {
      type: Boolean,
      required: true,
    },
    isActive: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {

    const isLastMenuItem = computed(() => props.currentItemIndex === props.totalItemsCount - 1);

    return {
      isLastMenuItem,
      LINK_TYPE,
    };
  
  },
});
</script>
